const enum VerticalAlignmentEnum {
  Top = 'top',
  Center = 'centre',
  Bottom = 'bottom',
}

export default VerticalAlignmentEnum;
